import { PlanEditor } from "@/components/plans/PlanEditor";

interface Props {
  planId: string;
  /** `?tab=changes` — a notice about a change opens the plan on its Changes tab. */
  initialTab?: "changes";
}

export function PlanEditorPage({ planId, initialTab }: Props) {
  return <PlanEditor planId={planId} initialTab={initialTab} />;
}
